(function () {

    'use strict';

    angular.module('iplusjs.utils.html', [
        'lodash',
        'modernizr',
        'iplusjs.utils.format',
        'iplusjs.utils.misc'
    ])
        .service('HtmlUtilsService', HtmlUtilsService);

    HtmlUtilsService.$inject = [
        '$log',
        '$window',
        '$anchorScroll',
        'lodash',
        'modernizr',
        'FormatUtilsService',
        'MiscUtilsService'
    ];
    function HtmlUtilsService($log, $window, $anchorScroll, _, modernizr, FormatUtilsService, MiscUtilsService) {
        var that = this,
            IE_WIN_ACCESS_ERROR = 'Call was rejected by callee.\r\n',
            testEl = $window.document.createElement('div'),
            textareaEl = $window.document.createElement('textarea'),
            observer;
        if (!testEl.scrollIntoViewIfNeeded && modernizr.intersectionobserver) {
            observer = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting !== true && entries[0].target && entries[0].target.scrollIntoView) {
                    entries[0].target.scrollIntoView();
                }

                observer.unobserve(entries[0].target);
            }, { threshold: [1] });
        }

        that.createSelectArray = createSelectArray;
        that.existsParent = existsParent;
        that.getYOffset = getYOffset;
        that.getYPosition = getYPosition;
        that.scrollTo = scrollTo;
        that.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
        that.scrollIntoView = scrollIntoView;
        that.openPopup = openPopup;
        that.getPopupCenter = getPopupCenter;
        that.isWindowClosed = isWindowClosed;
        that.getParent = getParent;
        that.getOpener = getOpener;
        that.composedPath = composedPath;
        that.hasElement = hasElement;
        that.hasClass = hasClass;
        that.stringToHTML = stringToHTML;
        that.escapeHTML = escapeHTML;
        that.elementsOverlapping = elementsOverlapping;
        function createSelectArray() {
            var args = Array.prototype.slice.call(arguments),
                lastValue = _.last(args),
                keyValue = [],
                formatCodeToBoolean = false,
                selectArray = [],
                wert,
                bezeichnung,
                idx,
                len;

            if (_.isBoolean(lastValue)) {
                formatCodeToBoolean = lastValue;
                args.splice(-1, 1);
            }

            for (idx = 0, len = args.length; idx < len; idx++) {
                if (_.isString(args[idx])) {
                    keyValue = args[idx].split('#');

                    wert = keyValue[0];
                    bezeichnung = keyValue[1];

                    selectArray.push({
                        wert: formatCodeToBoolean ? FormatUtilsService.toBoolean(wert) : wert,
                        bezeichnung: _.isUndefined(bezeichnung) ? wert : bezeichnung
                    });
                } else {
                    wert = _.get(args[idx], 'wert');
                    bezeichnung = _.get(args[idx], 'bezeichnung');

                    if (_.isUndefined(wert)) {
                        continue;
                    }

                    selectArray.push({
                        wert: formatCodeToBoolean ? FormatUtilsService.toBoolean(wert) : wert,
                        bezeichnung: _.isUndefined(bezeichnung) ? wert : bezeichnung
                    });
                }
            }

            return selectArray;
        }
        function existsParent() {
            return $window.parent && $window.parent !== $window;
        }
        function getYOffset(val) {
            var offset = val,
                elem;

            if (_.isFunction(offset)) {
                offset = offset();
            } else if (_.isElement(offset) && offset && _.isFunction(offset.getBoundingClientRect)) {
                elem = offset;
                offset = elem.getBoundingClientRect().bottom;
            } else if (!_.isNumber(offset)) {
                offset = 0;
            }

            return offset;
        }
        function getYPosition(elem) {
            var offsetGlobal = getYOffset($anchorScroll.yOffset),
                offsetElem;

            if (!_.isElement(elem)) {
                return 0;
            }

            offsetElem = getYOffset(elem);

            return offsetElem - offsetGlobal;
        }
        function scrollTo(elem, yOffset) {
            if (elem && _.isFunction(elem.scrollTo)) {
                elem.scrollTo(0, yOffset || 0);
            }
        }
        function scrollIntoViewIfNeeded(elem, forceScroll) {
            if (!elem) {
                return;
            }

            if (forceScroll) {
                elem.scrollIntoView();
                return;
            }

            if (elem.scrollIntoViewIfNeeded) {
                elem.scrollIntoViewIfNeeded();
            } else if (modernizr.intersectionobserver) {
                observer.observe(elem);
            } else {
                elem.scrollIntoView();
            }
        }
        function scrollIntoView(elem, options) {
            if (!elem) {
                return;
            }

            options = options || {};

            elem.scrollIntoView(options);
        }
        function openPopup(url, options) {
            var popupDimensions,
                popupOptions,
                popupPosition;

            options = options || {};

            popupDimensions = {
                width: options.width,
                height: options.height
            };

            popupOptions = options.popupOptions;

            if (MiscUtilsService.isEverythingNotEmpty(popupDimensions.width, popupDimensions.height)) {
                popupPosition = getPopupCenter(popupDimensions.width, popupDimensions.height);

                popupOptions = [
                    options.popupOptions,
                    'width=' + popupDimensions.width,
                    'height=' + popupDimensions.height,
                    'left=' + popupPosition.left,
                    'top=' + popupPosition.top
                ].join(',');
            }

            return $window.open(url, options.name, popupOptions);
        }
        function getPopupCenter(w, h) {
            var left,
                top;

            if (w) {
                if ($window.outerWidth) {
                    left = $window.Math.round(($window.outerWidth - w) / 2) + $window.screenX;
                } else if ($window.screen.width) {
                    left = $window.Math.round(($window.screen.width - w) / 2);
                }
            }

            if (h) {
                if ($window.outerHeight) {
                    top = $window.Math.round(($window.outerHeight - h) / 2) + $window.screenY;
                } else if ($window.screen.height) {
                    top = $window.Math.round(($window.screen.height - h) / 2);
                }
            }

            return {
                left: left,
                top: top
            };
        }
        function isWindowClosed(win) {
            try {
                if (win === $window) {
                    return false;
                }
            } catch (err) {
                return true;
            }

            try {
                if (!win) {
                    return true;
                }
            } catch (err) {
                return true;
            }

            try {
                if (win.closed) {
                    return true;
                }
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) {
                    return false;
                }

                return true;
            }
            try {
                if (!win.parent || !win.top) {
                    return true;
                }
            } catch (err) {
            }

            return false;
        }
        function getParent(win) {
            if (!win) {
                return;
            }

            try {
                if (win.parent && win.parent !== win) {
                    return win.parent;
                }
            } catch (err) {
            }

            return;
        }
        function getOpener(win) {
            if (!win) {
                return;
            }
            if (getParent(win)) {
                return;
            }

            try {
                return win.opener;
            } catch (err) {
            }

            return;
        }
        function composedPath(el) {
            var path = [];

            while (el) {
                path.push(el);

                if (el.tagName === 'HTML') {

                    path.push(document);
                    path.push(window);

                    return path;
                }

                el = el.parentElement;
            }
        }
        function hasElement(elements, nodeNames) {
            var val = false;

            if (!elements || !_.size(elements)) {
                return false;
            }

            if (!_.isArray(elements)) {
                return _.includes(nodeNames, elements.nodeName);
            }

            _.each(elements, function (el) {
                if (_.includes(nodeNames, el.nodeName)) {
                    val = true;
                    return false;
                }
            });

            return val;
        }
        function hasClass(elements, className) {
            var val = false;

            if (!elements || !_.size(elements)) {
                return false;
            }

            if (!_.isArray(elements)) {
                return angular.element(elements).hasClass(className);
            }

            _.each(elements, function (el) {
                if (angular.element(el).hasClass(className)) {
                    val = true;
                    return false;
                }
            });

            return val;
        }

        function stringToHTML(text) {
            var el = document.createElement('template');
            el.innerHTML = text;
            return el.content;
        }

        function escapeHTML(string) {
            textareaEl.textContent = string;
            return textareaEl.innerHTML;
        }

        function elementsOverlapping(elem1, elem2, elem1Overrides) {
            if (!elem1 || !elem2 || !elem1.getBoundingClientRect || !elem2.getBoundingClientRect) {
                return false;
            }

            elem1Overrides = elem1Overrides || {};

            var elem1BoundingClientRect = elem1.getBoundingClientRect() || {},
                elem2BoundingClientRect = elem2.getBoundingClientRect() || {};

            return !(
                (_.isNil(elem1Overrides.top) ? elem1BoundingClientRect.top : elem1Overrides.top) > elem2BoundingClientRect.bottom ||
                (_.isNil(elem1Overrides.right) ? elem1BoundingClientRect.right : elem1Overrides.right) < elem2BoundingClientRect.left ||
                (_.isNil(elem1Overrides.bottom) ? elem1BoundingClientRect.bottom : elem1Overrides.bottom) < elem2BoundingClientRect.top ||
                (_.isNil(elem1Overrides.left) ? elem1BoundingClientRect.left : elem1Overrides.left) > elem2BoundingClientRect.right
            );
        }

    }

})();
